// FrontendPrivateRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired } from '../../../utils/authUtils';

interface Props {
  children: React.ReactNode;
}

const FrontendPrivateRoute: React.FC<Props> = ({ children }) => {
  const token = localStorage.getItem('frontendUserToken');
  const location = useLocation();

  const isAuthenticated = token && !isTokenExpired(token);

  // If token is missing or expired, clear and redirect to user login
  if (!isAuthenticated) {
    localStorage.removeItem('frontendUserToken');
    localStorage.removeItem('frontendUserId');
    localStorage.removeItem('frontendUserType');
    localStorage.removeItem('frontendUserName');
    localStorage.removeItem('frontendUserEmail');

    return <Navigate to="/authuser/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default FrontendPrivateRoute;
